import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { firstValueFrom, Subscription } from 'rxjs';
import { SupportService } from 'src/app/support.service';
import { BankService } from '../bank.service';
import { MatDialog } from '@angular/material/dialog';
import { UpdateComponent as CreateMoveComponent } from 'src/app/docs/moving-money/update/update.component';
import { UpdateComponent as CreateAddComponent } from 'src/app/docs/import-money/update/update.component';
import { UpdateComponent as CreateWriteOffComponent } from 'src/app/docs/write-off-money/update/update.component';
import { Bank } from 'src/typings';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
  banks: Bank[] = [];

  loading = false;

  resultsLength = 0;

  isRateLimitReached = false;

  pageSize = 10;

  sort_active = 'description';

  sort_direction = 'asc';

  displayedColumns = ['id', 'description', 'moneyType', 'balance', 'action'];

  listSubs: Subscription | undefined;

  bankGW: Subscription | undefined;

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;

  @ViewChild(MatSort) sort: MatSort | undefined;

  constructor(
    private bankService: BankService,
    public supportService: SupportService,
    private dialog: MatDialog
  ) {
    this.bankGW = this.bankService.bankGW.subscribe(() => {
      this.search();
    });
  }

  ngOnDestroy(): void {
    this.listSubs?.unsubscribe();
    this.bankGW?.unsubscribe();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.search();
    });
  }

  sortData(event: any) {
    this.sort_active = event.active;
    this.sort_direction = event.direction;
    if (this.paginator) this.paginator.pageIndex = 0;
    this.searchByPage();
  }

  async searchByPage(page: number = 0) {
    this.loading = true;
    try {
      const data = await firstValueFrom(
        this.bankService.search({
          limit: this.pageSize,
          offset: page * this.pageSize,
          sort_action: this.sort_active,
          sort_direction: this.sort_direction
        })
      );
      this.loading = false;
      this.banks = data.data;
      this.resultsLength = data.length;
    } catch (err) {
      this.loading = false;
    }
  }

  search() {
    this.paginator?.firstPage();
    this.paginator?.page.subscribe((page) => {
      this.searchByPage(page.pageIndex);
    });
    this.searchByPage();
  }

  openMoveDialog(bank: Bank) {
    const dialogRef = this.dialog.open(CreateMoveComponent);
    dialogRef.componentInstance.bankFromFormControl.setValue(bank);
    dialogRef.componentInstance.dialogRef = dialogRef;
  }

  openWriteOffDialog(bank: Bank) {
    const dialogRef = this.dialog.open(CreateWriteOffComponent);
    dialogRef.componentInstance.bankFormControl.setValue(bank);
    dialogRef.componentInstance.dialogRef = dialogRef;
  }

  openAddDialog(bank: Bank) {
    const dialogRef = this.dialog.open(CreateAddComponent);
    dialogRef.componentInstance.bankFormControl.setValue(bank);
    dialogRef.componentInstance.dialogRef = dialogRef;
  }
}
